import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Theme } from '@material-ui/core/styles/createMuiTheme'
import { TableRowProps } from '@material-ui/core'
import TableRow from '@material-ui/core/TableRow'

interface Props {
  fade?: boolean
}

const useClasses = makeStyles((theme: Theme) => ({
  fade: {
    '& td': {
      color: theme.palette.grey['A200'],
    },
  },
}))

const ListTableRow = ({ fade, ...props }: TableRowProps & Props) => {
  const classes = useClasses()

  return <TableRow
    hover
    {...(fade && { className: classes.fade })}
    {...props}
  />
}

export default ListTableRow
